module.exports = "//public.zight.com/packs/media/images/microsoft_teams_logo-bf8c2490bc0532f9f6df1220eda1387e.svg";